var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconCalendar = function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.318 4.888v1.877c0 1.064.875 1.93 1.95 1.93a1.943 1.943 0 0 0 1.951-1.93V4.893c1.818.046 3.281 1.381 3.281 3.02v13.248c0 1.84-1.515 3.339-3.376 3.339H8.043c-1.862 0-3.376-1.498-3.376-3.339V7.913c0-1.62 1.43-2.943 3.217-3.017v1.869c0 1.064.875 1.93 1.951 1.93s1.951-.866 1.951-1.93V4.888h5.532zm4.648 6.2H7.201v9.021c0 1.04.855 1.886 1.906 1.886H20.06a1.898 1.898 0 0 0 1.907-1.886v-9.022zM9.836 3.5c.468 0 .849.376.849.84v2.425c0 .464-.38.84-.85.84a.844.844 0 0 1-.849-.84V4.34c0-.464.38-.84.85-.84zm9.433 0c.469 0 .848.376.85.84v2.425c0 .464-.381.84-.85.84a.845.845 0 0 1-.85-.84V4.34c0-.464.38-.84.85-.84z",
    fillRule: "evenodd"
  })));
};

export default SvgIconCalendar;